const Tiendas = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M17.986 6.146C18.1156 6.98736 15.7119 7.87929 13.9498 6.38007C13.1334 7.34162 11.1251 7.61364 9.38236 6.40537C8.98715 6.83554 7.87283 7.18979 6.93342 7.17082C6.11711 7.15816 5.3008 6.87982 4.69181 6.34843C3.40256 7.69587 -0.309693 7.47446 0.0207179 6.04479C0.370564 4.53287 1.54319 0.218539 1.82825 0.205887C2.11979 0.193235 15.0835 0.332407 15.4334 0.389341C15.7832 0.446275 17.9018 5.58299 17.986 6.146Z"
                fill="#696158"
            />
            <path
                d="M17.1701 14.5976C17.1766 14.7114 17.1766 14.838 17.1118 14.9392C16.9434 15.1859 14.2094 15.0973 13.581 15.1163C13.0627 15.1289 11.456 15.2238 11.3264 15.1416C11.2422 15.0847 11.9807 10.5805 8.90341 10.6501C5.82605 10.7197 7.2319 15.053 7.01163 15.1859C6.88854 15.2618 1.09664 15.091 1.04481 15.0404C0.999469 14.9961 1.22622 8.53723 1.22622 8.53723C2.34702 8.75868 3.94076 8.5056 4.69876 7.71481C5.30775 8.25252 6.12406 8.52457 6.94036 8.53723C7.87327 8.5562 8.99411 8.20192 9.38932 7.77179C11.1321 8.98004 13.1469 8.708 13.9567 7.74645C14.9674 8.6068 17.0211 8.42966 17.0211 8.42966C17.0211 8.42966 17.0924 12.3645 17.1701 14.5976Z"
                fill="#696158"
            />
        </svg>
    )
}

export default Tiendas
